import {
  PASSWORD_POLICY_NEW_MIN_LENGTH,
  PASSWORD_POLICY_OLD_MIN_LENGTH,
} from '../../authentication/passwordRequirementValidation'
import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_MODIFY_REGISTRATION } from '../model/EXPERIMENT_NAME'

/**
 * This hook provides configuration for the modify registration canary release,
 * such as whether a stronger password is required and the minimum password length.
 */

interface ModifyRegistrationExperimentConfig {
  experimentName: string
  isModifyRegistrationExperimentEnabled: boolean
  isStrongPasswordRequired: boolean
  minPasswordLength: number
}

export const useModifyRegistrationExperiment =
  (): ModifyRegistrationExperimentConfig => {
    const { isEnabled, name } = useGetExperiment(
      EXPERIMENT_NAME_MODIFY_REGISTRATION,
    )

    const minPasswordLength = isEnabled
      ? PASSWORD_POLICY_NEW_MIN_LENGTH
      : PASSWORD_POLICY_OLD_MIN_LENGTH

    return {
      experimentName: name,
      isModifyRegistrationExperimentEnabled: isEnabled,
      isStrongPasswordRequired: isEnabled,
      minPasswordLength,
    }
  }
